import Vue from "vue";
import Vuex from "vuex";
import eBird from "./eBird";
import * as R from "ramda";

Vue.use(Vuex);

const state = {
  busy: false,
  controls: {
    location: null,
    dist: 10,
    back: 7
  },
  observations: {},
  errors: []
};

const getters = {
  BUSY: state => {
    return state.busy;
  },
  LOCATION: state => {
    return state.controls.location;
  },
  OBSERVATION_COUNT: state => {
    return R.keys(state.observations).length;
  },
  TAXA: state => {
    const toTaxon = x => {
      return { comName: x.comName, sciName: x.sciName };
    };
    const toTaxa = R.map(toTaxon);
    const sortByComName = R.sortBy(R.prop("comName"));
    // Note: compose or pipe might be better here
    return sortByComName(R.uniq(toTaxa(R.values(state.observations))));
  },
  LOCATIONS: state => {
    const toLocation = x => {
      return {
        locId: x.locId,
        locName: x.locName,
        position: { lat: x.lat, lng: x.lng }
      };
    };
    const toLocations = R.map(toLocation);
    // Note: compose or pipe might be better here
    return R.uniq(toLocations(R.values(state.observations)));
  },
  ERRORS: state => {
    return state.errors;
  }
};

const mutations = {
  SET_BUSY: (state, val) => {
    state.busy = val;
  },
  SET_LOCATION: (state, coords) => {
    state.controls.location = {
      lat: coords.latitude,
      lng: coords.longitude
    };
  },
  SET_PLACE: (state, place) => {
    state.controls.location = {
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng()
    };
  },
  CLEAR_OBSERVATIONS: state => {
    state.observations = {};
  },
  ADD_OBSERVATIONS: (state, observations) => {
    // NOTE: this function hurts my head
    // const objFromListWith = R.curry((fn, list) =>
    //   R.chain(R.zipObj, R.map(fn))(list)
    // );
    const keys = R.map(R.prop("obsId"))(observations);
    const numRowsWithoutId = keys.filter(x => x === undefined).length;
    if (numRowsWithoutId > 0) {
      state.errors.push(
        `Each observation should have an observation id, but ${numRowsWithoutId} rows have none`
      );
    }
    const newObservations = R.zipObj(keys, observations);
    state.observations = {
      ...state.observations,
      ...newObservations
    };
  },
  ADD_ERROR: (state, error) => {
    state.errors.push(error);
  },
  CLEAR_ERROR: (state, index) => {
    state.errors.splice(index, 1);
  }
};

const locate = () => {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      pos => resolve(pos.coords),
      err => reject(err.message)
    );
  });
};

const actions = {
  GET_CURRENT_LOCATION: async context => {
    try {
      context.commit("SET_LOCATION", await locate());
      context.dispatch("FETCH_OBSERVATIONS");
    } catch (err) {
      context.commit("ADD_ERROR", err);
    }
  },
  FETCH_OBSERVATIONS: async context => {
    try {
      context.commit("CLEAR_OBSERVATIONS");
      const resp = await eBird.fetchObservations(state.controls);
      context.commit("ADD_OBSERVATIONS", resp.data);
    } catch (err) {
      context.commit("ADD_ERROR", err);
    }
  },
  SET_PLACE: async (context, place) => {
    try {
      context.commit("SET_PLACE", place);
      context.dispatch("FETCH_OBSERVATIONS");
    } catch (err) {
      context.commit("ADD_ERROR", err);
    }
  }
};

export default new Vuex.Store({
  // strict: true,
  state,
  getters,
  mutations,
  actions
});
